/*----------------------------------------------------------------------------
|   DownloadTableAsShownXLSX   -   returns a given HTML table as download
|                                  in form of an on-the-fly generated
|                                  compressed Excel XLSX file using XML 
|                                  and a minimal zip file generator
|
|
|   written by Jochen Loewer
|   Sept 2024
|                
\---------------------------------------------------------------------------*/


/*----------------------------------------------------------------------------
|   zip   -    minimal zip file generator
|
|   based on  https://en.wikipedia.org/wiki/ZIP_(file_format)
|                
\---------------------------------------------------------------------------*/
async function zip(files) {

    const crc32_table = function() {
        const tbl = [];
        var c;
        for(var n = 0; n < 256; n++) {
            c = n;
            for(var k =0; k < 8; k++) {
                c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
            }
            tbl[n] = c;
        }
        return tbl;
    } ();

    function crc32(arr) {
        var crc = -1;
        for(var i=0; i<arr.length; i++) {
            crc = (crc >>> 8) ^ crc32_table[(crc ^ arr[i]) & 0xFF];
        }
        return (crc ^ (-1)) >>> 0;
    }

    function putUint32s(arr, offset, ...values) {
        const dv = new DataView(arr.buffer);
        values.forEach( (v,i) => dv.setUint32(offset+i*4, v, true) );
    }

    function putUint16s(arr, offset, ...values) {
        const dv = new DataView(arr.buffer);
        values.forEach( (v,i) => dv.setUint16(offset+i*2, v, true) );
    }

    const records = [];
    const te = new TextEncoder('utf8');

    var offset = 0;
    var cdSz = 0;

    for (var i = 0; i < files.length; i++) {  

        var file = files[i]
    
        const fh = new Uint8Array(30+file.name.length);
        const fname = te.encode(file.name);
        const chksum = crc32(file.data);

 
        putUint32s(fh,  0, 0x04034b50);
        putUint32s(fh,  4, 0x00020014);       // set version and general purpose flags
        putUint32s(fh, 10, 0x00210000);       // date/time ?
        putUint16s(fh, 26, file.name.length); 
        
        if (typeof CompressionStream == "function") {
            // good, browser has support for fast deflate compression!
            var cs = new CompressionStream("deflate-raw");
            var writer = cs.writable.getWriter();
            writer.write(file.data);  writer.close();
            var compressedBlob =  new Uint8Array( await new Response(cs.readable).arrayBuffer() );
            putUint16s(fh, 8, 0x08);
            putUint32s(fh, 14, chksum, compressedBlob.length, file.data.length);            
        } else {
            var compressedBlob = null
            putUint16s(fh, 8, 0x00);  // store plain (uncompressed)
            putUint32s(fh, 14, chksum, file.data.length, file.data.length);
        }  
        fh.set(fname, 30);
        records.push(fh);
        
        if (compressedBlob) {            
            records.push(compressedBlob);
        } else {
            records.push(file.data);
        }
          
        file.header = fh;
        file.offset = offset;
        file.cdr    = new Uint8Array(46+file.name.length);

        putUint32s(file.cdr,  0, 0x02014b50);
        putUint32s(file.cdr,  4, 0x000a031e);
          
        if (compressedBlob) {
            putUint16s(file.cdr, 10, 8);
            putUint32s(file.cdr, 16, chksum, compressedBlob.length, file.data.length);
        } else {
            putUint32s(file.cdr, 16, chksum, file.data.length, file.data.length);
        }    
        putUint16s(file.cdr, 28, file.name.length);
        putUint32s(file.cdr, 42, offset);

        file.cdr.set(fname, 46);

        cdSz += file.cdr.length;
        if (compressedBlob) {
            offset += file.header.length + compressedBlob.length;
        } else {
            offset += file.header.length + file.data.length;
        }
    }

    files.forEach( f => records.push(f.cdr) );
    
    const eocd = new Uint8Array(22);

    putUint32s(eocd, 0, 0x06054b50);
    putUint16s(eocd, 8, files.length, files.length);
    putUint32s(eocd, 12, cdSz, offset);

    records.push(eocd);

    return new Blob(records, { type : 'application/zip' } );
}


/*----------------------------------------------------------------------------
|   Helper functions
|   
|   GetColumnWidths - calculates the width of each column
|   GenerateStylesXML - generates the styles XML for the Excel file
|
\---------------------------------------------------------------------------*/


function GetColumnWidths(cols, rows) {
    // calculate width of each columns (throughout all rows and column header)
    var cw = [];
    for (var i=0; i < cols.length; i++) {
        cw.push(cols[i].length);
    }
    var tmplen = 0;
    for (var r=0; r < rows.length; r++) {
        for (var i=0; i < cols.length; i++) {
            if (rows[r][i] == null) {
                tmplen = 0;
            } else
            if (rows[r][i] instanceof Date) {
               tmplen = 10;
            } else {
               tmplen = (rows[r][i]+'').length;
            }
            if (tmplen > 40 ) {
                tmplen = 40;
            }
            if (tmplen > cw[i]) {
                cw[i] = tmplen;
            }
        }
    }
    return cw;
}

function GenerateStylesXML() {

    var Styles
        = '<?xml version="1.0" encoding="UTF-8"?>'
        + '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'
        + ' <numFmts count="1">'
        + '  <numFmt numFmtId="164" formatCode="General"/>'
        + '  <numFmt numFmtId="168" formatCode="?"/>'
        + '  <numFmt numFmtId="169" formatCode="yyyy\\-mm\\-dd"/>'
        + '  <numFmt numFmtId="170" formatCode="0.00"/>'
        + ' </numFmts>'
        + ' <fonts count="2">'
        + '   <font>'
        + '     <sz val="10"/>'
        + '     <name val="Calibri"/>'
        + '     <family val="2"/>'
        + '   </font>'
        + '   <font>'
        + '     <color rgb="FFFFFFFF"/>'
        + '     <b val="true"/>'
        + '     <sz val="10"/>'
        + '     <name val="Calibri"/>'
        + '     <family val="2"/>'
        + '   </font>'
        + ' </fonts>'
        + ' <fills count="4">'
        + '  <fill>'
        + '    <patternFill patternType="none"/>'
        + '  </fill>'
        + '  <fill>'
        + '    <patternFill patternType="gray125"/>'
        + '  </fill>'
        + '  <fill>'
        + '    <patternFill patternType="solid">'
        + '      <fgColor rgb="FF0096D6"/>'
        + '      <bgColor rgb="FF0096D6"/>'
        + '    </patternFill>'
        + '  </fill>'
        + '  <fill>'
        + '    <patternFill patternType="solid">'
        + '      <fgColor rgb="FF767676"/>'
        + '      <bgColor rgb="FF767676"/>'
        + '    </patternFill>'
        + '  </fill>'
        + ' </fills>'
        + ' <borders count="1">'
        + '   <border diagonalDown="false" diagonalUp="false">'
        + '     <left/>'
        + '     <right/>'
        + '     <top/>'
        + '     <bottom/>'
        + '     <diagonal/>'
        + '   </border>'
        + ' </borders>'
        + ' <cellStyleXfs count="1">'
        + '   <xf numFmtId="0" fontId="0" fillId="0" borderId="0"/>'
        + ' </cellStyleXfs>'
        + ' <cellXfs count="4">'
        + '   <xf applyAlignment="false" applyBorder="false" applyFont="false" applyProtection="false" borderId="0" fillId="0" fontId="0" numFmtId="164" xfId="0">'
        + '     <alignment horizontal="general" indent="0" shrinkToFit="false" textRotation="0" vertical="bottom" wrapText="false"/>'
        + '     <protection hidden="false" locked="true"/>'
        + '   </xf>'
        + '   <xf applyAlignment="false" applyBorder="false" applyFont="true" applyProtection="false" borderId="0" fillId="2" fontId="1" numFmtId="164" xfId="0">'
        + '     <alignment horizontal="general" indent="0" shrinkToFit="false" textRotation="0" vertical="bottom" wrapText="false"/>'
        + '     <protection hidden="false" locked="true"/>'
        + '   </xf>'
        + '   <xf applyAlignment="false" applyBorder="false" applyFont="true" applyProtection="false" borderId="0" fillId="0" fontId="0" numFmtId="169" xfId="0">'
        + '     <alignment horizontal="general" indent="0" shrinkToFit="false" textRotation="0" vertical="bottom" wrapText="false"/>'
        + '     <protection hidden="false" locked="true"/>'
        + '   </xf>'
        + '   <xf applyAlignment="false" applyBorder="false" applyFont="true" applyProtection="false" borderId="0" fillId="3" fontId="1" numFmtId="164" xfId="0">'
        + '     <alignment horizontal="general" indent="0" shrinkToFit="false" textRotation="0" vertical="bottom" wrapText="false"/>'
        + '     <protection hidden="false" locked="true"/>'
        + '   </xf>'
        + ' </cellXfs>'
        + ' <cellStyles count="1">'
        + '    <cellStyle name="Normal" xfId="0" builtinId="0"/>'
        + ' </cellStyles>'
        + ' <dxfs count="0"/>'
        + '</styleSheet>'
    ;
    return Styles;
}

/*----------------------------------------------------------------------------
|   DownloadTableAsShownXLSX   -  returns a given HTML tables as download
|                                 in form of an on-the-fly generated
|                                 compress Excel XLSX file
|
|                
\---------------------------------------------------------------------------*/
export async function DownloadTableAsShownXLSX( tableRef, downloadName, expectInnerTable ) {

    function ToColName(i) {
    
        var f = Math.floor(i / 26);
        var s = Math.floor(i % 26);
        var l = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        if (f == 0) {
            return l[s]; 
        }
        return l[f-1]+l[s];
    }
    
    function EscapeHTML(s) {

        if (typeof s !== 'string' && s !== null && s !== undefined && s !== "") {
            // If not a string, convert to string
            s = String(s);
        }
        return s.replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')   // to please jmacs "
                .replace(/'/g, '&apos;');
    }
    
    function GetInnerText(el) {
        if (typeof el == "string") return el;
        if (typeof el == "undefined") { return el };
        //if (el.innerText) return el.innerText;   
        var str = "";        
        var cs = el.childNodes;
        var l = cs.length;
        for (var i = 0; i < l; i++) {
            switch (cs[i].nodeType) {
                case 1: // ELEMENT_NODE
                    //str += GetInnerText(cs[i]);
                    if (!(
                           (cs[i].nodeName == "SPAN" && cs[i].className == "dd-label-popup")
                        || (cs[i].nodeName == "SPAN" && cs[i].className == "mouseover-popup-content")
                        || (cs[i].nodeName == "SPAN" && cs[i].className.match(/texticon-info/))
                        || (cs[i].nodeName == "SPAN" && cs[i].className.match(/texticon-success/))
                        || (cs[i].nodeName == "UL"   && cs[i].className == "sandy-btn-popup-menu")
                    )) {
                        if (cs[i].nodeName == "SPAN" && cs[i].className.match(/redbold/)) {
                            str += "<span style='color:red;font-weight:700;'>"+GetInnerText(cs[i])+"</span>"
                        } else {
                            str += GetInnerText(cs[i]);
                        }
                    }
                    if (str == '' && cs[i].childNodes.length==0) {
                        if (cs[i].nodeName == 'IMG') {
                            if (cs[i].getAttribute('label')) {
                                str = cs[i].getAttribute('label');
                            }
                        }
                    }
                    break;
                case 3: // TEXT_NODE
                    //if (str != "") { str += "&nbsp;" }
                    str += cs[i].nodeValue.trim();
                    break;
            }
        }
        return str;
    }

  
    const te = new TextEncoder('utf8');


    var Empty = '';
    
    var ContentTypes 
        = '<?xml version="1.0" encoding="UTF-8"?>'
        + '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">'
        + '  <Default ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings" Extension="bin"/>'
        + '  <Default ContentType="application/vnd.openxmlformats-package.relationships+xml" Extension="rels" />'
        + '  <Default ContentType="application/xml" Extension="xml"/>'
        + '  <Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" PartName="/xl/workbook.xml"/>'
        + '  <Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" PartName="/xl/styles.xml"/>'
        + '  <Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" PartName="/xl/worksheets/sheet1.xml"/>'
        + '</Types>'
    ;
    var Rels
        = '<?xml version="1.0" encoding="UTF-8"?>'
        + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
        + '  <Relationship Id="rId1" Target="xl/workbook.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument"/>'
        + '</Relationships>'
    ; 
    var Workbook 
        = '<?xml version="1.0" encoding="UTF-8"?>'
        + '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'
     // + '  <fileVersion appName="xl" lastEdited="7" lowestEdited="7" rupBuild="27726"/>'
        + '  <workbookPr defaultThemeVersion="124226"/>'
        + '  <bookViews>'
        + '    <workbookView activeTab="0"/>'
        + '  </bookViews>'
        + '  <sheets>' 
        + '    <sheet xmlns:ns0="http://schemas.openxmlformats.org/officeDocument/2006/relationships" ns0:id="rId3" name="Extract" sheetId="1"/>'
        + '  </sheets>'
        + '  <calcPr calcId="0"/>'
        + '</workbook>'
    ;
    var WorkbookRels
        = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
        + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
        + '  <Relationship Id="rId2" Target="/xl/styles.xml"            Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles"/>'
        + '  <Relationship Id="rId3" Target="/xl/worksheets/sheet1.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet"/>'
        + '</Relationships>'
    ;    
    var Styles = GenerateStylesXML();
        

    var cols = [];
    var rows = [];

    if (typeof tableRef == "string") {
        // HTML id given as reference
        var table = document.getElementById(tableRef); 
    } else {
        // DOM node fgiven as reference
        var table = tableRef
    }        

    var firstHdrTD = table.querySelector('thead tr:first-child th');
    if (firstHdrTD == null) {
        firstHdrTD = table.querySelector('thead tr:first-child td');
    }
    if (tableRef == 'fl_viewprice') {
        firstHdrTD = table.querySelector('thead tr:nth-child(2) td');
    }
    //console.log(table);
    //console.log(firstHdrTD);
    var tr = firstHdrTD.parentNode;
    var el = firstHdrTD;
    while (el) {
        if (el.nodeType == 1) {
            let txt = GetInnerText(el);
            cols.push(txt);
        }
        el = el.nextSibling;
    }
    //console.log(content);
    
    tr = table.querySelector('tbody tr:first-child');
    while (tr) {
        //console.log(tr.nodeType); 
        let innerTable = expectInnerTable ? tr.querySelector('table') : null;
        // if there is an inner table, we need to handle it differently
        if (innerTable) {
            // get inner table header
            let innerHdr = innerTable.querySelector('tr:first-child th');
            let innerCols = [];
            while (innerHdr) {
                if (innerHdr.nodeType == 1) {
                    let txt = GetInnerText(innerHdr);
                    innerCols.push(txt);
                }
                innerHdr = innerHdr.nextSibling;
            }
            rows.push({ innerTable: true, innerCols: innerCols, innerData: [] });

            // get inner table data
            let innerRow = innerTable.querySelector('tr:nth-child(2)');
            while (innerRow) {
                let innerTD = innerRow.firstChild;
                let innerRowData = [];
                while (innerTD) {
                    if (innerTD.nodeType == 1) {
                        let txt = GetInnerText(innerTD);
                        innerRowData.push(txt);
                    }
                    innerTD = innerTD.nextSibling;
                }
                let rowCount = rows.length - 1;
                rows[rowCount].innerData.push(innerRowData);
                innerRow = innerRow.nextSibling;
            }
        } else {
            if (tr.nodeType == 1) {
                var row = [];
                var td = tr.firstChild;
                if ( ! td.className.match(/simpleDataGridBundleHeader/) ) {
                    while (td) {
                        if (td.nodeType == 1) {
                            let txt = GetInnerText(td)
                            txt = txt.replace(/\u2022/,'');
                            if (td.firstChild != null && td.firstChild.className == "shipment-row") { 
                                txt = td.firstChild.id;
                            }
                            row.push(txt);
                        }
                        td = td.nextSibling;
                    }
                }    
                rows.push(row);
            }
        }
        tr = tr.nextSibling;
    }

    var cw = GetColumnWidths(cols, rows);

    var nrCols = cols.length;
    var nrRows = rows.length;
    
    var endCell = ToColName(nrCols-1)+''+(nrRows+1);

    var Sheet 
        = '<?xml version="1.0" encoding="UTF-8"?>'
        + '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'
        + '  <sheetViews>'
        + '    <sheetView tabSelected="true" workbookViewId="0">'
        + '      <pane ySplit="1" topLeftCell="A2" activePane="bottomLeft" state="frozen"/>'
        + '    </sheetView>'
        + '  </sheetViews>'
      //+ '  <sheetFormatPr defaultRowHeight="15" x14ac:dyDescent="0.2"/>'
    ;

    //--- output first row, ie. column header...
    Sheet += '<cols>';
    for (var i=0; i < cols.length; i++) {a
        Sheet += '<col min="'+(i+1)+'" max="'+(i+1)+'" width="'+(1.0+cw[i]*1.2).toFixed(0)+'"/>'
    }
    Sheet += '</cols>';
    Sheet += '<sheetData>';

    //-- blue header row
    Sheet += '<row r="1">';
    for (var i=0; i < cols.length; i++) {
        var cnm = ToColName(i);
        Sheet += '<c r="'+cnm+'1" s="1" t="inlineStr"><is><t>'+EscapeHTML(cols[i])+'</t></is></c>'
    }
    Sheet += '</row>\n';
 
   
    //-- then all normal data rows...
    var rn = 1;
    var c = '';        
    for (var r=0; r < rows.length; r++) {
        // if this is a normal row
        if (!rows[r].innerTable) {
            rn++;
            c += '<row r="'+rn+'">';
            for (var i=0; i < cols.length; i++) {
                var cnm = ToColName(i);
                if (rows[r][i] instanceof Date && rows[r][i] != "Invalid Date") {
                    c += '<c r="'+cnm+rn+'" s="2" t="d"><v>'
                    + rows[r][i].toISOString().substr(0,19)
                    + '</v></c>'
                } else
                if (typeof rows[r][i] == 'number') {
                    c += '<c r="'+cnm+rn+'" s="0" t="n"><v>'
                    + rows[r][i]
                    + '</v></c>'
                } else
                if (rows[r][i] == null) {
                    c += '<c r="'+cnm+rn+'" s="0" t="inlineStr"><is><t></t></is></c>'
                } else {
                    c += '<c r="'+cnm+rn+'" s="0" t="inlineStr"><is><t>'
                    + EscapeHTML( rows[r][i] )
                    + '</t></is></c>'
                }
            }
            c += '</row>\n';
        } // if innerTable
        else {
            if (rows[r].innerCols) {
                rn++;
                c += '<row r="'+rn+'">';
                // skip one cell
                c += '<c r="A'+rn+'" s="0" t="inlineStr"><is><t></t></is></c>';
                for (var i=0; i < rows[r].innerCols.length; i++) {
                    // start at second cell
                    let cnm = ToColName(i+1);
                    c += '<c r="'+cnm+rn+'" s="3" t="inlineStr"><is><t>'+EscapeHTML(rows[r].innerCols[i])+'</t></is></c>';
                }
                c += '</row>\n';
            }
            if (rows[r].innerData) {
                for (var i=0; i < rows[r].innerData.length; i++) {
                    rn++;
                    c += '<row r="'+rn+'">';
                    for (var j=0; j < rows[r].innerData[i].length; j++) {
                        // start at second cell
                        let cnm = ToColName(j+1);
                        if (rows[r].innerData[i][j] instanceof Date && rows[r].innerData[i][j] != "Invalid Date") {
                            c += '<c r="'+cnm+rn+'" s="2" t="d"><v>'
                              + rows[r].innerData[i][j].toISOString().substr(0,19)
                              + '</v></c>'
                        } else  if (typeof rows[r].innerData[i][j] == 'number') {
                            c += '<c r="'+cnm+rn+'" s="0" t="n"><v>'
                              + rows[r].innerData[i][j]
                              + '</v></c>'
                        } else {
                            c += '<c r="'+cnm+rn+'" s="0" t="inlineStr"><is><t>'
                              + EscapeHTML(rows[r].innerData[i][j])
                              + '</t></is></c>';
                        }
                    }
                    c += '</row>\n';
                }
            }
        }
    }
    Sheet += c;

    Sheet += ' </sheetData>'
          +  ' <autoFilter ref="A1:'+endCell+'"/>'
          +  ' <ignoredErrors>'
          +  '   <ignoredError sqref="A2:'+endCell+'" numberStoredAsText="1"/>'
          +  ' </ignoredErrors>'
          +  '</worksheet>'
    
           
    var blob = await zip( [
        { name: "[Content_Types].xml",        data: te.encode(ContentTypes ) },
        { name: "_rels/",                     data: te.encode(Empty)         },
        { name: "_rels/.rels",                data: te.encode(Rels)          },
        { name: "xl/",                        data: te.encode(Empty)         },
        { name: "xl/styles.xml",              data: te.encode(Styles)        },        
        { name: "xl/workbook.xml",            data: te.encode(Workbook)      },         
        { name: "xl/worksheets/",             data: te.encode(Empty)         },
        { name: "xl/worksheets/sheet1.xml",   data: te.encode(Sheet)         },
        { name: "xl/_rels/",                  data: te.encode(Empty)         },
        { name: "xl/_rels/workbook.xml.rels", data: te.encode(WorkbookRels)  }
    ]);
    
    var url = URL.createObjectURL(blob);
    
    // console.log(url);
    var a = document.createElement('a');
    a.href = url;
    setTimeout(function() {
        window.URL.revokeObjectURL(url);
    }, 4000);          
    
    var fileName = 'exportAsShown';
    if (downloadName) {
        fileName = downloadName;
    }
    fileName  += '_'
              +  (new Date().toISOString().replace(/[TZ :-]/g,'').substring(0,14))
              +  '.xlsx'
    
    
    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

/* --------------------------------------------------------------------------
|  DownloadMultiSheetDataAsXLSX   -  returns a given array of data sheets as download
|                                    in form of an on-the-fly generated 
|                                    compress Excel XLSX file
|
\---------------------------------------------------------------------------*/


export async function DownloadMultiSheetDataAsXLSX(sheetData, downloadName) {

    function ToColName(i) {

        var f = Math.floor(i / 26);
        var s = Math.floor(i % 26);
        var l = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        if (f == 0) {
            return l[s];
        }
        return l[f-1]+l[s];
    }

    function EscapeHTML(s) {

        if (typeof s !== 'string' && s !== null && s !== undefined && s !== "") {
            // If not a string, convert to string
            s = String(s);
        }
        return s.replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')   // to please jmacs "
                .replace(/'/g, '&apos;');
    }

    const te = new TextEncoder('utf8');
    var Empty = '';

    var ContentTypes = '<?xml version="1.0" encoding="UTF-8"?>'
        + '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">'
        + '  <Default ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings" Extension="bin"/>'
        + '  <Default ContentType="application/vnd.openxmlformats-package.relationships+xml" Extension="rels" />'
        + '  <Default ContentType="application/xml" Extension="xml"/>'
        + '  <Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" PartName="/xl/workbook.xml"/>'
        + '  <Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" PartName="/xl/styles.xml"/>'
        + '</Types>';


    var Rels = '<?xml version="1.0" encoding="UTF-8"?>'
        + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
        + '  <Relationship Id="rId1" Target="xl/workbook.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument"/>'
        + '</Relationships>';

    var Styles = GenerateStylesXML();

    var Workbook = '<?xml version="1.0" encoding="UTF-8"?>'
        + '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'
        + '  <workbookPr defaultThemeVersion="124226"/>'
        + '  <bookViews>'
        + '    <workbookView activeTab="0"/>'
        + '  </bookViews>'
        + '  <sheets>';

    var WorkbookRels = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
        + '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
        + '  <Relationship Id="rId2" Target="/xl/styles.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles"/>';

    var sheetFiles = [];
    for (let i = 0; i < sheetData.length; i++) {

        let cols = sheetData[i].cols;
        let rows = sheetData[i].rows;

        if (!cols || !rows || !cols.length || !rows.length) {
            // skip this sheet
            continue;
        }

        let sheetName = sheetData[i].name || `Sheet${i + 1}`;
        Workbook += `    <sheet xmlns:ns0="http://schemas.openxmlformats.org/officeDocument/2006/relationships" ns0:id="rId${i + 3}" name="${sheetName}" sheetId="${i + 1}"/>`;
        WorkbookRels += `  <Relationship Id="rId${i + 3}" Target="/xl/worksheets/sheet${i + 1}.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet"/>`;

        var cw = GetColumnWidths(cols, rows);

        var nrCols = cols.length;
        var nrRows = rows.length;
        var endCell = ToColName(nrCols - 1) + '' + (nrRows + 1);

        var Sheet = '<?xml version="1.0" encoding="UTF-8"?>'
            + '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'
            + '  <sheetViews>'
            + '    <sheetView tabSelected="true" workbookViewId="0">'
            + '      <pane ySplit="1" topLeftCell="A2" activePane="bottomLeft" state="frozen"/>'
            + '    </sheetView>'
            + '  </sheetViews>';

        Sheet += '<cols>';
        for (var j = 0; j < cols.length; j++) {
            Sheet += '<col min="' + (j + 1) + '" max="' + (j + 1) + '" width="' + (1.0 + cw[j] * 1.2).toFixed(0) + '"/>'
        }
        Sheet += '</cols>';
        Sheet += '<sheetData>';

        Sheet += '<row r="1">';
        for (var j = 0; j < cols.length; j++) {
            var cnm = ToColName(j);
            Sheet += '<c r="' + cnm + '1" s="1" t="inlineStr"><is><t>' + EscapeHTML(cols[j]) + '</t></is></c>'
        }
        Sheet += '</row>\n';

        var rn = 1;
        var c = '';
        for (var r = 0; r < rows.length; r++) {
            rn++;
            c += '<row r="' + rn + '">';
            for (var j = 0; j < cols.length; j++) {
                var cnm = ToColName(j);
                if (rows[r][j] instanceof Date && rows[r][j] != "Invalid Date") {
                    c += '<c r="' + cnm + rn + '" s="2" t="d"><v>'
                        + rows[r][j].toISOString().substr(0, 19)
                        + '</v></c>'
                } else if (typeof rows[r][j] == 'number') {
                    c += '<c r="' + cnm + rn + '" s="0" t="n"><v>'
                        + rows[r][j]
                        + '</v></c>'
                } else if (rows[r][j] == null) {
                    c += '<c r="' + cnm + rn + '" s="0" t="inlineStr"><is><t></t></is></c>'
                } else {
                    c += '<c r="' + cnm + rn + '" s="0" t="inlineStr"><is><t>'
                        + EscapeHTML(rows[r][j])
                        + '</t></is></c>'
                }
            }
            c += '</row>\n';
        }
        Sheet += c;

        Sheet += ' </sheetData>'
            + ' <autoFilter ref="A1:' + endCell + '"/>'
            + ' <ignoredErrors>'
            + '   <ignoredError sqref="A2:' + endCell + '" numberStoredAsText="1"/>'
            + ' </ignoredErrors>'
            + '</worksheet>';

        sheetFiles.push({ name: `xl/worksheets/sheet${i + 1}.xml`, data: te.encode(Sheet) });
    }

    Workbook += '  </sheets>'
        + '  <calcPr calcId="0"/>'
        + '</workbook>';

    WorkbookRels += '</Relationships>';

    var blob = await zip([
        { name: "[Content_Types].xml",          data: te.encode(ContentTypes) },
        { name: "_rels/",                       data: te.encode(Empty) },
        { name: "_rels/.rels",                  data: te.encode(Rels) },
        { name: "xl/",                          data: te.encode(Empty) },
        { name: "xl/styles.xml",                data: te.encode(Styles) },
        { name: "xl/workbook.xml",              data: te.encode(Workbook) },
        { name: "xl/_rels/",                    data: te.encode(Empty) },
        { name: "xl/_rels/workbook.xml.rels",   data: te.encode(WorkbookRels) },
        ...sheetFiles
    ]);

    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    setTimeout(function () {
        window.URL.revokeObjectURL(url);
    }, 4000);

    var fileName = 'exportData';
    if (downloadName) {
        fileName = downloadName;
    }
    fileName += '_'
        + (new Date().toISOString().replace(/[TZ :-]/g, '').substring(0, 14))
        + '.xlsx';

    a.setAttribute('download', fileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}



